<template>
  <div @click="togglePreview()"></div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    session: {
      type: OT.Session,
      required: true
    }
  }
})
export default class PublisherScreen extends Vue {
  data () {
    return {
      publisher: {
        options: {
          maxResolution: { width: 1280, height: 720 },
          videoSource: 'screen',
          audioSource: false,
          publishAudio: false,
          name: 'screen',
          style: {
            nameDisplayMode: 'off',
            buttonDisplayMode: 'off'
          }
        },
        stream: null
      }
    }
  }

  mounted () {
    if (this.$store.state.storage.device.screen) {
      this.shareScreen()
    }
  }

  handlerError (error) {
    if (error) {
      console.log('screen handlerError', error)
      this.resetPublisher()
    }
  }
  screenElement () {
    const screenPreview = document.createElement('div')
    screenPreview.setAttribute('id', 'screen-preview')
    this.$el.appendChild(screenPreview)

    return screenPreview
  }

  publishScreen () {
    if (this.publisher.stream) {
      this.disconnectPublisher()
      return false
    }

    this.shareScreen()
  }

  shareScreen () {
    const constraints = {
      video: true,
      audio: false
    }

    window.navigator.mediaDevices.getDisplayMedia(constraints)
      .then(async (mediaStream) => {
        this.publisher.options.videoSource = mediaStream.getVideoTracks()[0]
        this.createPublisher()
        this.session.publish(this.publisher.stream, this.handlerError)
      })
      .catch((error) => {
        this.resetPublisher()
        this.$emit('error', error, 'publisherScreen')
      })
  }

  createPublisher () {
    const screenElement = document.querySelector('#screen-preview') ? document.querySelector('#screen-preview') : this.screenElement()
    this.publisher.stream = OT.initPublisher(screenElement, this.publisher.options, this.handlerError)

    this.publisher.stream.on('streamDestroyed', (event) => {
      if (!event.reason === 'reset') {
        this.resetPublisher()
      }

      if (event.reason === 'mediaStopped' || event.reason === 'unpublished') {
        this.stopPublish()
      }
    })
  }

  destroy () {
    if (this.publisher.stream) {
      this.publisher.stream.destroy()
      this.resetPublisher()
    }
  }

  resetPublisher () {
    this.publisher.stream = null
    this.$store.state.storage.device.screen = false
    this.$storage.updateStorageData()
  }

  async disconnectPublisher () {
    this.session.unpublish(this.publisher.stream)
  }

  stopPublish () {
    try {
      this.publisher.stream.destroy()
      this.resetPublisher()
    } catch (error) {
      console.log('stopPublish ERROR', error)
    }
  }

  togglePreview () {
    this.$el.classList.toggle('active')
  }
}
</script>
